import {
  DropdownMenuSubTriggerProps,
  SubContent,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

const DropdownSubContent: React.FunctionComponent<
  DropdownMenuSubTriggerProps
> = ({ children }) => {
  return <SubContent className={styles.menu}>{children}</SubContent>;
};

export default DropdownSubContent;
